import { type FunctionComponent } from 'react';
import { useCustomer } from '../../../../hooks/apollo/customer/customer.hooks';
import { QuickShip } from '../../../quick-ship/quick-ship.component';
import AlertTriangleIcon from '../../../svgs/untitled-ui/alert-triangle.svg';

export type ShippingProps = {
	isQuickShip: boolean;
	message: string;
	hasSalesRestriction: boolean;
};

export const Shipping: FunctionComponent<ShippingProps> = ({ isQuickShip, message, hasSalesRestriction }) => {
	const location = useCustomer()?.data?.customer?.location;

	if (hasSalesRestriction && location?.state) {
		return (
			<div className="flex items-center f6" data-testid="productCardSaleRestriction">
				<AlertTriangleIcon className="mr1 theme-review" />
				<span>Not available in {location.state.name}</span>
			</div>
		);
	}

	if (isQuickShip && message) {
		return <QuickShip message={message} messageClasses="f6 font-medium" dataTestId="productCardQuickShipInfo" />;
	}

	return <div className="f6 font-medium">{message}</div>;
};
